/**
 * Helper penanganan error terpusat.
 *
 * Tujuan: menggantikan pola `catch (error) {}` yang menelan error tanpa jejak,
 * serta akses tidak aman seperti `error.response.data.error` (bisa crash saat
 * network error / error tanpa response).
 */

/**
 * Ambil pesan error yang aman untuk ditampilkan ke user.
 *
 * Mendukung berbagai bentuk respons backend:
 *  - { error: "..." }
 *  - { message: "..." }
 *  - { messages: { message: "..." } }  (CI4 validation)
 *  - error.message (network/timeout)
 *
 * @param {unknown} error
 * @param {string} fallback - pesan default bila tidak ada yang bisa diambil
 * @returns {string}
 */
export const getErrorMessage = (error, fallback = 'Terjadi kesalahan. Silakan coba lagi.') => {
    if (!error) return fallback;

    const data = error.response?.data;
    if (data) {
        if (typeof data === 'string') return data;
        if (typeof data.error === 'string') return data.error;
        if (typeof data.message === 'string') return data.message;
        if (typeof data.messages?.message === 'string') return data.messages.message;
        // CI4 mengembalikan { messages: { field: "pesan" } }
        if (data.messages && typeof data.messages === 'object') {
            const first = Object.values(data.messages)[0];
            if (typeof first === 'string') return first;
        }
    }

    if (typeof error.message === 'string' && error.message) return error.message;

    return fallback;
};

/**
 * Catat error ke console dengan konteks (label) yang konsisten.
 * @param {string} label
 * @param {unknown} error
 */
export const logError = (label, error) => {
    // eslint-disable-next-line no-console
    console.error(label, error?.response?.data || error?.response || error?.message || error);
};
